export const toggleNavbar = () => ({
    type: "TOGGLE_NAVBAR",
})

export const closeNavbar = () => ({
    type: "CLOSE_NAVBAR",
})